import React from "react";
import { Provider } from "react-redux";
import { Persistor } from "redux-persist";
import { PersistGate } from "redux-persist/integration/react";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Store } from "redux";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import ErrorBoundary from "#components/ErrorBoundary/ErrorBoundary";

import ReduxContext from "#components/ReduxContext";
import { AppState } from "#store/types";

// global theme — totally fine to customize later
const theme = createTheme();

// Create QueryClient instance
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
      staleTime: 5 * 60 * 1000,
    },
  },
});

interface ProvidersProps {
  store: Store<AppState>;
  persistor: Persistor;
  children: React.ReactNode;
}

const Providers: React.FC<ProvidersProps> = ({
  store,
  persistor,
  children,
}) => {
  return (
    <Provider store={store}>
      <ReduxContext.Provider value={{ persistor }}>
        <PersistGate loading={null} persistor={persistor}>
          <QueryClientProvider client={queryClient}>
            <ThemeProvider theme={theme}>
              <BrowserRouter>
                <ErrorBoundary>{children}</ErrorBoundary>
              </BrowserRouter>
            </ThemeProvider>
          </QueryClientProvider>
        </PersistGate>
      </ReduxContext.Provider>
    </Provider>
  );
};

export default Providers;
